import { render, staticRenderFns } from "./imageCategory.vue?vue&type=template&id=96397c78&scoped=true"
import script from "./imageCategory.vue?vue&type=script&lang=js"
export * from "./imageCategory.vue?vue&type=script&lang=js"
import style0 from "./imageCategory.vue?vue&type=style&index=0&id=96397c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96397c78",
  null
  
)

export default component.exports